import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('bringozSpaceWords', bringozSpaceWordsFilter);

function bringozSpaceWordsFilter() {
  return function bringozSpaceWordsFilter(text) {
    if (text) {
      return text.replace(/([a-z])([A-Z])/g, "$1 $2");
    }
  }
}
